"use client";

import { Fragment } from "react";
import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import Image from "next/image";

interface LoadingProps {
  isOpen: boolean;
  message?: string;
}

export function Loading({
  isOpen,
  message = "The page is loading",
}: LoadingProps) {
  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={() => {}}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-white transition-opacity" />
        </TransitionChild>
        <div className="fixed inset-0 z-10 flex items-center justify-center">
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <DialogPanel className="flex flex-col items-center justify-center space-y-1.5 p-8">
              <div className="flex justify-center items-center">
                {/* <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 animate-spin border-t-cyan-400 border-b-red-500 border-r-cyan-950 border-l-yellow-500" /> */}
                <Image
                  src="/images/logoicon.svg"
                  alt="Rawiah"
                  width={50}
                  height={50}
                  quality={1}
                  priority={true}
                  className="animate-bounce"
                />
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
}
